import React, { useState, useEffect, useContext } from 'react';
import {format, subDays, startOfMonth} from "date-fns";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
  import { Bar } from 'react-chartjs-2';  

import * as net from "../lib/net";
import Dt_Txt from "../lib/ui/dt_txt";

//import PdfDlg from "./dlg/pdf_dlg";
//import LoginDlg from "./dlg/login_dlg";

import sso from "../sso.js";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

class CCS_Dash extends React.Component {

    constructor(props, context) {
        super(props);

        this.store = props.store;
        this.state = {};
        this.state.gaa = [];
        this.state.loading = 0;
        this.state.sdo = {};
        this.state.eka = [];

        this.state.tot = {};
        this.state.tot.netto = "";
        this.state.tot.brutto = "";
        this.state.tot.resultat = "";

        this.state.today = new Date();
        var hh = this.state.today.getHours();
        if(hh < 5) this.state.today.setDate(this.state.today.getDate() - 1);

        var dts = format(this.state.today, "yyyy-MM-dd");
        this.state.tdts = dts;
        this.state.dts = dts;

        this.baroptions = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: 'top',
              },
              title: {
                display: true,
                text: 'Transaktioner',
              },
            },
          };
          
        //this.state.bardata = {};

        const labels = ['Enhet 1', 'Enhet 2', 'Enhet 3', 'Enhet 4', 'Enhet 5', 'Enhet 6', 'Enhet 7'];
        this.state.bardata = {
            labels,
            datasets: [
              {
                label: 'Dataset 1',
                //data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
                data: [112, 334, 32, 57],
                backgroundColor: '#800',
              },
              {
                label: 'Dataset 2',
                data: [765, 237, 49, 459],
                backgroundColor: '#080',
              },
            ],
          };
    }

    componentDidMount(){
        this.st_oms();
    }

    componentWillUnmount(){
    }

    row_css(row) {
        var css = {};
        if(this.state.row) {
            if(this.state.row.ank == row.ank) {
                css.background = "#080";
                css.color = "#fff";
            }
        }
        return css;
    }
    tb_style() {
        var css = {};
        css.height = window.innerHeight - 225;
        css.overflow = "auto";
        return css;
    }
    dt_dts(e) {
        //alert(JSON.stringify(e));
        var dts = format(e, "yyyy-MM-dd");
        this.setState({ dts: dts });
    }

    st_oms() {
        var self = this;
    
        var sdo = {};
        sdo.eko = {};
        //var fdat = format(this.state.fdat, "yyyy-MM-dd");
        //var tdat = format(this.state.tdat, "yyyy-MM-dd");
        var fdat = this.state.dts;
        var tdat = this.state.dts;
    
        var reqfkn = "pos.pos_eko.st_oms";
        if(this.state.tdts != this.state.dts) reqfkn = "pos.pos_eko.sth_oms";

        //var csa = self.get_csa();
        var csa = sso.sdo.csa;

          function send_req(cso) {
              const promise1 = new Promise((resolve, reject) => {
                  //setTimeout(resolve, 500, 'one');
                  var prm = {};
                  prm.sid = cso.c0sid;
                  prm.req = reqfkn;
                  prm.avd = cso.c0avd;
                  if(cso.c0dpa) prm.dpa = JSON.stringify(cso.c0dpa);
                  prm.fdat = fdat;
                  prm.tdat = tdat;
                  //alert(JSON.stringify(prm));
    
                  net.sid_req(prm)
                  .then(function(ret){
                      //alert(JSON.stringify(ret));
                      //alert(JSON.stringify(ret.rco.tot));
                      //sdo.eko[sid] = ret.rco;
                      sdo.eko[cso.c0sid] = {};
                      sdo.eko[cso.c0sid].lopnr = cso.c0lopnr;
                      sdo.eko[cso.c0sid].text = cso.c0text;
                      sdo.eko[cso.c0sid].tot = ret.rco.tot;
                      resolve();
                  })
                  .catch(function(e){
                      var txt = JSON.stringify(e);
                  });
              });
            return promise1;
          }
          var qa = [];
          for(var so of csa) {
              var promise = send_req(so);
              qa.push(promise);
          }
        Promise.all(qa)
        .then(function(ret){
            //alert(JSON.stringify(ret));
            //var eka = Object.values(sdo.eko);
            var tot = {};
            tot.netto = 0;
            tot.brutto = 0;
            tot.resultat = 0;
            var eka = [];

            var labels = [];
            var datasets = [];
            var ds_netto = {};
            ds_netto.label = "Netto";
            ds_netto.data = [];
            ds_netto.backgroundColor = '#800';
            var ds_brutto = {};
            ds_brutto.label = "Brutto";
            ds_brutto.data = [];
            ds_brutto.backgroundColor = '#008';
        
            var keys = Object.keys(sdo.eko);
            //alert(JSON.stringify(keys));
            keys.sort();
            for(var key of keys) {
                var o = sdo.eko[key];

                //if(key == "S0004102") alert(JSON.stringify(o));
                labels.push( o.text );
                var netto = Math.round((o.tot.netto * 1) / 100);
                ds_netto.data.push( netto );
                var brutto = Math.round((o.tot.brutto * 1) / 100);
                ds_brutto.data.push( brutto );

                tot.netto = tot.netto + (o.tot.netto * 1);
                tot.brutto = tot.brutto + (o.tot.brutto * 1);
                tot.resultat = tot.resultat + (o.tot.resultat * 1);
                eka.push(o);
            }
            //alert(JSON.stringify(labels));
            //alert(JSON.stringify(datasets));
            //alert(JSON.stringify(data));
            datasets.push( ds_netto );
            datasets.push( ds_brutto );

            var bardata = {
                labels,
                datasets: datasets
              };
               self.setState({sdo: sdo, eka: eka, tot: tot, bardata: bardata });
    /*
            var sdo = ret.rco;
            var a = [];
            var keys = Object.keys(sdo.dto);
            for(var key of keys) {
                var o = sdo.dto[key];
                a.push( o );
            }
            a.push( sdo.tot );
            //self.setState({dto: dto, eka: a }, () => self.line_chart());
            self.setState({sdo: sdo, eka: a });
     */
        })
        .catch(function(e){
            var txt = JSON.stringify(e);
        });
      }
    
    render() {
/*
        var stat = [];
        var keys = Object.keys(this.state.stat);
        for (var key of keys) {
            var row = this.state.stat[key];
            stat.push(row);
        }
*/

        return (
            <div className="web-content flex-column">


            <div className="d-flex flex-row justify-content-between">
                <div className="">DASHBOARD</div>
            </div>
                <div className="flex-row justify-content-between">
                    <Dt_Txt dts={this.state.dts} getValue={(e)=> this.dt_dts(e) }/>
                    <div className="cdiblue" onClick={() => this.st_oms() }>UPPDATERA</div>
                </div>
                <div className="flex-col flex">

                <div className="" style={ this.tb_style() }>
                <Bar className="" options={this.baroptions} data={this.state.bardata} />
                </div>

            </div>
            <div className="">
                <div className="txt_14">Avdelningar : { this.state.eka.length }</div>
            </div>

         </div>
        );
    }

}
//WebPub.contextType = SDOContext; // Function
export default CCS_Dash;
